import React, { useEffect, useRef, useState } from 'react'
import { supabase } from '../lib/supabase'
import { formatServiceMoney } from '../lib/serviceMenu'

export default function JobCataloguePriceRepair({ job, profile, onApplied }) {
  if (profile?.role !== 'owner' || profile.workshop_id !== job.workshop_id) return null
  return <Repair key={JSON.stringify([job.id, job.financial_revision_key, profile.id, profile.workshop_id])} job={job} onApplied={onApplied} />
}

function Repair({ job, onApplied }) {
  const [preview, setPreview] = useState(null)
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)
  const alive = useRef(true)
  const pending = useRef(false)
  const request = useRef(null)
  useEffect(() => {
    alive.current = true
    supabase.rpc('preview_job_catalogue_price_repair', { p_job_id: job.id }).then(({ data, error: failure }) => {
      if (!alive.current) return
      if (failure) { setError(failure.message); return }
      if (data?.job_id !== job.id || data.financial_revision_key !== job.financial_revision_key
        || !Number.isSafeInteger(data.prices?.tax?.gross_minor)) { setError('The service price could not be checked. Reload this job.'); return }
      setPreview(data)
    }).catch(failure => { if (alive.current) setError(failure.message) })
    return () => { alive.current = false }
  }, [job.id, job.financial_revision_key])
  async function apply() {
    if (pending.current || !preview) return
    pending.current = true
    setBusy(true)
    setError('')
    request.current ||= crypto.randomUUID()
    try {
      const { data, error: failure } = await supabase.rpc('apply_job_catalogue_price_repair', {
        p_job_id: job.id, p_idempotency_key: request.current, p_expected_repair: preview,
      })
      if (failure) throw new Error(failure.message)
      if (data?.job?.id !== job.id || data.job.workshop_id !== job.workshop_id) throw new Error('The saved job could not be confirmed.')
      if (alive.current) await onApplied(data.job)
    } catch (failure) { if (alive.current) setError(failure.message) }
    finally { pending.current = false; if (alive.current) setBusy(false) }
  }
  return <div className="alert alert-info" aria-label="Restore service price">
    {preview && <><p>Saved service price: <strong>{formatServiceMoney(preview.prices.tax.gross_minor / 100)}</strong>
      {preview.prices.configuration.registration === 'registered' ? ` including ${formatServiceMoney(preview.prices.tax.tax_minor / 100)} VAT` : ''}.</p>
      <button className="btn btn-primary btn-sm" type="button" disabled={busy} onClick={apply}>{busy ? 'Saving...' : 'Apply service price'}</button></>}
    {!preview && !error && <p>Checking saved service price...</p>}
    {error && <p role="alert">{error}</p>}
  </div>
}
